<template>
    <div class="flex h-auto bg-gray-900 text-white">
      <!-- Sidebar -->
      <aside class="w-64 bg-gray-800 p-6 flex flex-col space-y-6 shadow-lg bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700">
        <div class="flex items-center justify-center space-x-3">
       <img src="@/assets/logo.svg" alt="Vultric Logo" class="h-20">
        </div>
        <Navbar></Navbar>
      </aside>
      
      <!-- Main Content -->
      <div class="flex-1 flex flex-col">
        <!-- Top Navbar -->
         <Header></Header>
        
        <!-- Support Page Content -->
        <main class="p-6 flex-1">
          <div class="p-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                      rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold mb-4">Support Tickets</h3>
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="bg-gray-700">
                  <th class="p-3 rounded-tl-lg">Ticket ID</th>
                  <th class="p-3">Subject</th>
                  <th class="p-3">Priority</th>
                  <th class="p-3">Status</th>
                  <th class="p-3 rounded-tr-lg">Last Updated</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ticket in tickets" :key="ticket.id" class="border-t border-gray-700 hover:bg-gray-600 transition cursor-pointer" @click="goToTicket(ticket.id)">
                  <td class="p-3 font-semibold">#{{ ticket.id }}</td>
                  <td class="p-3">{{ ticket.subject }}</td>
                  <td class="p-3">{{ ticket.priority }}</td>
                  <td class="p-3">
                    <span :class="statusClass(ticket.status)" class="px-2 py-1 rounded-lg">{{ ticket.status }}</span>
                  </td>
                  <td class="p-3">{{ ticket.date || "Just Now" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div class="p-6 mt-6 bg-gradient-to-b from-gray-800 to-gray-900 border border-gray-700 
                      rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition">
            <h3 class="text-lg font-semibold mb-4">Submit a New Ticket</h3>
            <input type="text" placeholder="Subject" v-model="newTicket.subject" class="w-full p-3 rounded bg-gray-700 mb-3 border border-gray-600">
            <select v-model="newTicket.priority" class="w-full p-3 rounded bg-gray-700 mb-3 border border-gray-600">
              <option value="Low">Low Priority</option>
              <option value="Medium">Medium Priority</option>
              <option value="High">High Priority</option>
            </select>
            <textarea placeholder="Describe your issue..." v-model="newTicket.description" class="w-full p-3 rounded bg-gray-700 mb-3 border border-gray-600"></textarea>
            <label class="block text-gray-400 mb-2">Attachment</label>
            <input type="file" class="w-full p-3 rounded bg-gray-700 mb-3 border border-gray-600">
            <button @click="submitTicket" class="bg-blue-500 p-3 rounded-lg hover:bg-blue-600 transition w-full">Submit Ticket</button>
          </div>
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/nav.vue';
  import Header from '@/components/header.vue';
  import axios from 'axios';

      export default {
        name: "CloudSupport",
        data() {
            return {
                tickets: [],
                newTicket: { subject: "", priority: "Low", description: "" }
            };
        },
        methods: {
            async fetchTickets() {
                try {
                    const response = await axios.get('https://api.syniac.com:3000/api/ticket/list', { withCredentials: true });
                    console.log(response.data)
                    this.tickets = response.data.tickets;
                } catch (error) {
                    console.error("Error fetching tickets:", error);
                }
            },
            async submitTicket() {
                if (this.newTicket.subject && this.newTicket.description) {
                    try {
                        const response = await axios.post('https://api.syniac.com:3000/api/ticket/add', this.newTicket, { withCredentials: true });
                        this.tickets.unshift(response.data);
                        this.newTicket = { subject: "", priority: "Low", description: "" };
                    } catch (error) {
                        console.error("Error submitting ticket:", error);
                    }
                }
            },
            goToTicket(ticketID) {
                this.$router.push(`/view_ticket/${ticketID}`);
            },
            statusClass(status) {
                return status === "Open" ? "bg-green-500 text-white px-2 py-1 rounded" : "bg-gray-500 text-white px-2 py-1 rounded";
            },
        },
        components: {
          Navbar,
          Header
        },
        mounted() {
            this.fetchTickets();
        }
    };
  </script>
  
